import { checkIsCountdownPass } from "./methods/checkIsCountdownPass";
import { checkIsDbsCoupon } from "./methods/checkIsDbsCoupon";
import { checkIsLocalUse } from "./methods/checkIsLocalUse";
import { checkIsOldQrPass } from "./methods/checkIsOldQrPass";
import { checkIsQrPass } from "./methods/checkIsQrPass";
import { checkIsQrSliderPass } from "./methods/checkIsQrSliderPass";
import { checkIsQrTicketGate } from "./methods/checkIsQrTicketGate";
import { checkIsCenteredQrReloadSection } from "./methods/checkIsCenteredQrReloadSection";
import { checkIsValidQrCode } from "./methods/checkIsValidQrCode";
import { getUsePassIndex } from "./methods/getUsePassIndex";
import { getStartAt } from "./methods/getStartAt";
import { getLimitedAt } from "./methods/getLimitedAt";
import { getSectionName, getSectionSuffix } from "./methods/getSectionDisplay";
import { checkShouldShowDividerLine } from "./methods/checkShouldShowDividerLine";
import { isValidTicketColor } from "./methods/isValidTicketColor";

export default {
  checkIsCountdownPass,
  checkIsDbsCoupon,
  checkIsLocalUse,
  checkIsOldQrPass,
  checkIsQrPass,
  checkIsQrSliderPass,
  checkIsQrTicketGate,
  checkIsValidQrCode,
  checkIsCenteredQrReloadSection,
  getUsePassIndex,
  getStartAt,
  getLimitedAt,
  getSectionName,
  getSectionSuffix,
  checkShouldShowDividerLine,
  isValidTicketColor,
};
